import { render, staticRenderFns } from "./CollaborationBrowsing.vue?vue&type=template&id=2f2012f3&scoped=true"
import script from "./CollaborationBrowsing.vue?vue&type=script&lang=js"
export * from "./CollaborationBrowsing.vue?vue&type=script&lang=js"
import style0 from "./CollaborationBrowsing.vue?vue&type=style&index=0&id=2f2012f3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2012f3",
  null
  
)

export default component.exports